import React from 'react';

import UserDetailsPage from 'components/users/UserList/userDetail';

const UserDetail = ({ history }) => <UserDetailsPage history={history} />;

export default UserDetail;
